import type React from 'react';

import { TextEditorAdapter } from '@components/TextEditor/TextEditorAdapter';
import { SpreadsheetAdapter } from '@components/Spreadsheet/SpreadsheetAdapter';
import { WetlabWorkflowAdapter } from '@components/WetlabWorkflow/WetlabWorkflowAdapter';
import { RunInfoAdapter } from '@components/RunStage/RunInfoAdapter';
import { RunAnalysisAdapter } from '@components/RunStage/RunAnalysisAdapter';
import { GraphViewerAdapter } from '@components/GraphViewer/GraphViewerAdapter';
// import { GanttAdapter } from '@components/Gantt/GanttAdapter';
import type { ComponentType } from '@/types/communication.types';

type ComponentRegistry = Partial<Record<ComponentType, React.ComponentType>>;

export const componentRegistry: ComponentRegistry = {
  textEditor: TextEditorAdapter,
  spreadsheet: SpreadsheetAdapter,
  workflow: WetlabWorkflowAdapter,
  runInfo: RunInfoAdapter,
  runAnalysis: RunAnalysisAdapter,
  graphViewer: GraphViewerAdapter,
  // gantt: GanttAdapter,
};

export function resolveRequestedComponent(
  requested: string | null,
  enabledComponents: ComponentType[]
): ComponentType {
  console.log(enabledComponents)
  // Prefer runInfo as fallback when it's enabled, otherwise first enabled component
  const fallback = enabledComponents.includes('runInfo')
    ? 'runInfo'
    : enabledComponents.includes('textEditor')
      ? 'textEditor'
      : enabledComponents[0];

  if (!requested) {
    return fallback;
  }

  if (!Object.prototype.hasOwnProperty.call(componentRegistry, requested)) {
    return fallback;
  }

  const asComponent = requested as ComponentType;
  
  // Always allow runAnalysis to be selected (it's a core feature, not dependent on enabledComponents config)
  if (asComponent === 'runAnalysis') {
    return asComponent;
  }
  
  if (!enabledComponents.includes(asComponent)) {
    return fallback;
  }

  return asComponent;
}
